import { forwardRef } from "react";
function SvgRawMinusIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={21}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M2 10.734a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8-10c-5.523 0-10 4.478-10 10 0 5.523 4.477 10 10 10s10-4.477 10-10c0-5.522-4.477-10-10-10Zm-4 9a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H6Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawMinusIcon);
export default ForwardRef;
